export function useSurfaceEditorStoreUIPositioning() {
  const isContextBarAbove = ref(false);

  function setIsContextBarAbove(isAbove) {
    isContextBarAbove.value = isAbove;
  }

  return {
    setIsContextBarAbove,
    isContextBarAbove
  };
}
